<template>
  <div id="receipt">
    <!-- Mailing(s) -->
    <div class="group1">
      <div v-for="(receipt, index) in receipts" :key="index">
        <div class="wrap">
          <h1 class="logo">배달의민족</h1>

          <div class="receipt selectArea">
            <!-- 신용카드 매출전표(s) -->
            <h2>신용카드 매출전표</h2>
            <table class="tb_type1">
              <colgroup>
                <col width="20%" />
                <col width="20%" />
                <col width="40%" />
                <col width="20%" />
              </colgroup>
              <tr>
                <th>승인번호</th>
                <th>카드종류</th>
                <th>카드번호</th>
                <th>할부</th>
              </tr>
              <tr class="line">
                <td>{{ receipt.approvalNumber }}</td>
                <td>{{ receipt.cardName }}</td>
                <td>{{ receipt.cardNumber }}</td>
                <td>{{ receipt.quota }}</td>
              </tr>
              <tr>
                <th colspan="2">결제일자</th>
                <th>취소일자</th>
                <th>주문상품</th>
              </tr>
              <tr class="line">
                <td colspan="2">{{ formatDate(receipt.approvalDateTime) }}</td>
                <td style="font-weight: bold" class="t_point1">{{ formatDate(receipt.cancelDateTime) }}</td>
                <td>{{ receipt.orderProductName }}</td>
              </tr>
              <tr>
                <th colspan="4">주문번호</th>
              </tr>
              <tr>
                <td colspan="4">{{ orderId }}</td>
              </tr>
            </table>
            <!-- 신용카드 매출전표(e) -->

            <!-- 가맹점 정보(s) -->
            <h3>가맹점 정보</h3>
            <table class="tb_type1">
              <colgroup>
                <col width="50%" />
                <col width="50%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>가맹점</th>
                  <th>대표자명</th>
                </tr>
                <tr class="line">
                  <td>{{receipt.corporateName}}</td>
                  <td>{{receipt.ceoName}}</td>
                </tr>
                <tr>
                  <th>사업자등록번호</th>
                  <th>가맹점 전화번호</th>
                </tr>
                <tr class="line">
                  <td>{{receipt.businessRegistrationNumber}}</td>
                  <td>{{receipt.corporatePhoneNumber}}</td>
                </tr>
                <tr>
                  <th colspan="2">가맹점 주소</th>
                </tr>
                <tr>
                  <td colspan="2">{{receipt.corporateAddress}}</td>
                </tr>
              </tbody>
            </table>
            <!-- 가맹점 정보(e) -->

            <!-- 판매자/배달대행자 정보(s) -->
            <h3> {{getNameType(receipt.type)}} 정보</h3>
            <table class="tb_type1">
              <colgroup>
                <col width="50%" />
                <col width="50%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>{{getNameType(receipt.type)}} 상호</th>
                  <th>대표자명</th>
                </tr>
                <tr class="line">
                  <td>{{receipt.sellerCorporateName}}</td>
                  <td>{{receipt.sellerCeoName}}</td>
                </tr>
                <tr>
                  <th>사업자등록번호</th>
                  <th>{{getNameType(receipt.type)}} 전화번호</th>
                </tr>
                <tr class="line">
                  <td>{{receipt.sellerBusinessRegistrationNumber}}</td>
                  <td>{{receipt.sellerCorporatePhoneNumber}}</td>
                </tr>
                <tr>
                  <th colspan="2">{{getNameType(receipt.type)}} 사업장 주소</th>
                </tr>
                <tr>
                  <td colspan="2">{{receipt.sellerCorporateAddress}}</td>
                </tr>
              </tbody>
            </table>
            <!-- 판매자 정보(e) -->

            <!-- 금액(s) -->
            <h3 class="t_point1">금액</h3>
            <table class="tb_type2">
              <colgroup>
                <col width="*" />
                <col width="28px" />
                <col width="28px" />
                <col width="28px" />
                <col width="28px" />
                <col width="28px" />
                <col width="28px" />
                <col width="28px" />
                <col width="28px" />
                <col width="28px" />
              </colgroup>
              <tbody>
                <tr class="line">
                  <th>금액</th>
                  <td v-for="(char, index) in priceChars(receipt)">
                    <p :class="{ t_point2: getPriceClass(index) }" v-html="getPriceUnit(index)"></p>
                    <span v-html="char"></span>
                  </td>
                </tr>
                <tr class="line">
                  <th>부가세</th>
                  <td v-for="char in taxChars(receipt)" v-html="char"></td>
                </tr>
                <tr style="font-weight: bold">
                  <th class="t_point1">합계</th>
                  <td class="t_point1" v-for="char in totalChars(receipt)" v-html="char"></td>
                </tr>
              </tbody>
            </table>
            <!-- 금액(e) -->
          </div>
        </div>
      </div>
  </div>
  <!-- Button(s) -->
    <div class="btn_area">
      <a href="javascript:print();">인쇄하기</a>
    </div>
</template>

<script>
export default {
  name: 'Receipt',
  methods: {
    priceChars(receipt) {
      if (!receipt) return []
      return this.priceToChars(receipt.supplyAmount)
    },
    taxChars(receipt) {
      if (!receipt) return []
      return this.priceToChars(receipt.vatAmount)
    },
    totalChars(receipt) {
      if (!receipt) return []
      return this.priceToChars(receipt.amount)
    },
    getPriceClass(index) {
      switch (index) {
        case 2:
        case 5:
        case 8:
          return true
        default:
          return false
      }
    },
    getPriceUnit(index) {
      switch (index) {
        case 2:
          return '백'
        case 5:
          return '천'
        case 8:
          return '원'
        default:
          return '&nbsp;'
      }
    },
    getNameType(type){
      switch (type) {
        case 'SALE':
          return '판매자'
        case 'DELIVERY':
          return '배달대행자'
        default:
          return '판매자'
      }
    },
    priceToChars(price) {
      let priceCharCount = 9
      let priceChars = String(price).split('')
      let whiteSpaces = ' '
        .repeat(priceCharCount - priceChars.length)
        .split('')
        .map(() => '&nbsp;')
      whiteSpaces.forEach((e) => priceChars.unshift(e))
      return priceChars
    },
    formatDate(date) {
      if (date == null) {
        return ''
      }
      return date.replace(/T/, ' ')
    }
  },
  data() {
    return {
      receipts: []
    }
  },
  created() {
    const paymentKey = this.$route.query.paymentKey
    if (!paymentKey) {
      window.location.href = '/error'
      return
    }
    this.$http.get(`/v1/payment/approval/receipt/${paymentKey}`).then(
      (response) => {
        this.receipts = response.data.result.receipts
        this.orderId = response.data.result.orderId
      },
      () => {
        location.href = '/error'
      }
    )
  }
}
</script>

<style scoped lang="scss">
#receipt {
  background: white;
  img {
    border: 0 none;
  }

  div,
  p,
  span,
  ul,
  li,
  h1,
  h2,
  form,
  ul,
  li,
  dl,
  dt,
  dd,
  fieldset,
  input,
  td,
  th {
    margin: 0;
    padding: 0;
  }

  ul li {
    list-style-type: none;
  }

  a {
    color: #444;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  .group1 {
    display: flex;
    justify-content: center;
  }

  .group2 {
    width: 50%;
    float: right;
  }

  .wrap {
    .logo {
      margin: 30px auto;
      text-align: center;
      width: 157px;
      height: 58px;
      text-indent: -9999px;
      background: url(~@/presentationals/v1/assets/images/receipt-logo.gif) no-repeat;
    }

    .receipt {
      margin: 0 auto;
      padding: 30px;
      width: 520px;
      border: 1px solid #ccc;

      h2 {
        margin: 0 0 20px;
        font-size: 18px;
        text-align: center;
      }

      h3 {
        margin: 30px 0 1px;
        font-size: 13px;
      }

      .tb_type1 {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        word-break: break-all;
        border-top: 3px solid #000;
        border-bottom: 1px solid #e5e5e5;

        th {
          padding: 8px 0 2px;
          font-size: 11px;
          font-weight: normal;
          text-align: left;
          vertical-align: top;
          color: #a3a3a3;
        }

        td {
          padding: 0 0 6px;
          vertical-align: top;
        }
      }

      .tb_type2 {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        word-break: break-all;
        border-top: 3px solid #ff4200;
        border-bottom: 1px solid #e5e5e5;
        border-right: 1px dashed #e5e5e5;

        th {
          font-size: 11px;
          font-weight: normal;
          text-align: left;
          color: #000;
        }

        td {
          height: 50px;
          border-left: 1px dashed #e5e5e5;
          text-align: center;
        }
      }

      .line {
        border-bottom: 1px solid #e5e5e5;
      }

      .t_point1 {
        color: #ff4200 !important;
      }

      .t_point2 {
        color: #a3a3a3;
        font-size: 11px;
        padding-bottom: 5px;
      }
    }

    .notice {
      text-align: center;
      font-size: 12px;
      padding-top: 25px;
    }
  }

  .btn_area {
    clear: both;
    padding: 30px 0;
    text-align: center;
  }

  .btn_area a {
    display: inline-block;
    width: 212px;
    height: 77px;
    text-indent: -9999px;
    background: url(~@/presentationals/v1/assets/images/receipt-print-button.gif) no-repeat;
  }
}

@media print {
  #receipt {
    .wrap {
      padding-top: 35px;

      .logo {
        display: none;
      }

      .receipt {
        width: 460px;

        h2 {
          font-weight: bold;
        }

        .line {
          border-bottom: 1px solid #cfcfcf;
        }

        .tb_type1 {
          border-bottom: 1px solid #cfcfcf;

          th {
            color: #878787;
            font-size: 8pt;
          }

          td {
            font-size: 10pt;
            letter-spacing: 1px;
          }
        }

        .tb_type2 {
          border-bottom: 1px solid #cfcfcf;
          border-right: 1px dashed #cfcfcf;

          td {
            border-left: 1px dashed #cfcfcf;
          }
        }

        .t_point1 {
          font-weight: bold;
        }

        .t_point2 {
          color: #cfcfcf;
          padding-bottom: 6px;
        }
      }
    }

    .btn_area {
      display: none;
    }
  }
}
</style>
